import {
    FIND_FUNRURAL_PENDING,
    FIND_FUNRURAL_SUCCESS,
    FIND_FUNRURAL_FAILURE,
    CREATE_FUNRURAL_PENDING,
    CREATE_FUNRURAL_SUCCESS,
    CREATE_FUNRURAL_FAILURE,
} from './actionTypes';


const initialState = { list: null, loading: false }


function funruralReducer(state = initialState, action) {

    switch (action.type) {
        case FIND_FUNRURAL_PENDING:
        case CREATE_FUNRURAL_PENDING:
            return {
                ...state,
                loading: true,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case FIND_FUNRURAL_SUCCESS:
            return {
                ...state,
                registro: action.registro,
                loading: false
            }
        case FIND_FUNRURAL_FAILURE:
            return {
                ...state,
                registro: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case CREATE_FUNRURAL_SUCCESS:
        case CREATE_FUNRURAL_FAILURE:
            return {
                ...state,
                loading: false,
                registro: action.registro,
                isCadastroRapido: false,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        default:
            return state
    }
}

export { funruralReducer };